import React, { useState, useEffect, useLayoutEffect } from 'react'
import { If } from 'react-extras'

import { Col, Row, Card, Typography, Switch, Select, Spin } from 'antd'
import { groupBy } from 'lodash'

import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import PageHeader from '../../components/PageHeader/PageHeader'
import './styles.css'

const EditProfile = function ({ match, history }) {
  const [formValues, setFormValues] = useState({})
  const [entitlements, setEntitlements] = useState([])
  const [groupedEntitlements, setGroupedEntitlements] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [profileEntitlements, setProfileEntitlements] = useState([])

  const [profiles, setProfiles] = useState([])

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.PROFILE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    retrieveEntitlements()
    retrieveProfiles()
  }, [])

  useEffect(() => {
    resetEntitlements()
    if (profileEntitlements.length > 0) {
      updateEntitlements(profileEntitlements)
    } else {
      setIsLoading(false)
    }
  }, [profileEntitlements])

  async function retrieveProfiles() {
    request(api.listProfiles({ active: true }), true).then((data) => {
      const formattedProfiles = data.map((v) => ({ value: v.id, description: v.name }))
      setProfiles(formattedProfiles)
    })
  }

  async function retrieveEntitlements() {
    request(api.retrieveEntitlements()).then((data) => {
      setGroupedEntitlements(groupBy(data, (b) => b.groupName))
      setEntitlements(data)
    })
  }

  async function associateProfileEntitlements(entitlementId) {
    const payload = {
      entitlementId: +entitlementId,
      profileId: +formValues.profile
    }
    request(api.associateProfile(payload), true).then(() => {
      const newFormValues = { ...formValues }
      newFormValues[`loading_${entitlementId}`] = false
      newFormValues[`entitlement_${entitlementId}`] = true
      setFormValues(newFormValues)
    })
  }

  async function disassociateProfileEntitlements(entitlementId) {
    const response = await api.retrieveEntitlementsByProfile({
      profileId: formValues.profile,
      entitlementId: entitlementId
    })

    request(api.disassociateProfile(response[0].id, { active: false }), true).then(() => {
      const newFormValues = { ...formValues }
      newFormValues[`loading_${entitlementId}`] = false
      newFormValues[`entitlement_${entitlementId}`] = false
      setFormValues(newFormValues)
    })
  }

  function resetEntitlements() {
    const newFormValues = {}
    newFormValues.profile = formValues.profile
    entitlements.forEach((entitlement) => {
      newFormValues[`entitlement_${entitlement.id}`] = false
      newFormValues[`loading_${entitlement.id}`] = false
    })
    setFormValues(newFormValues)
  }

  function updateEntitlements(listEntitlements) {
    const newFormValues = { ...formValues }
    const mappedListEntitlements = listEntitlements.map((entitlement) => entitlement.entitlementId)
    entitlements.forEach((entitlement) => {
      newFormValues[`loading_${entitlement.id}`] = false
      if (mappedListEntitlements.includes(entitlement.id)) {
        newFormValues[`entitlement_${entitlement.id}`] = true
      } else {
        newFormValues[`entitlement_${entitlement.id}`] = false
      }
    })

    setFormValues(newFormValues)
    setIsLoading(false)
  }

  function onChangeSelectProfile(value) {
    setIsLoading(true)
    request(api.retrieveEntitlementsByProfileId(value)).then((data) => {
      const formattedResponse = data.map((d) => ({
        entitlementId: +d.entitlementId,
        profileId: +d.profileId
      }))
      setProfileEntitlements(formattedResponse)
    })
    setFormValues({
      ...formValues,
      profile: value
    })
  }

  function renderEntitlementsByGroupName() {
    if (!formValues.profile || isLoading === true) {
      return null
    }
    return Object.keys(groupedEntitlements).map((group) => {
      return (
        <div key={`idGroupCol_${group}`}>
          <Typography.Title className="default-header-title" level={4}>
            {group}
          </Typography.Title>
          <Row type="flex" justify="start" style={{ marginLeft: '10%' }}>
            {groupedEntitlements[group].map((currentEntitlement) => {
              return (
                <Col span={8} key={`idCol_${currentEntitlement.id}`}>
                  <div style={{ display: 'flex', marginTop: '20px' }}>
                    <Typography.Text
                      style={{ width: '50%', marginRight: '15px', textAlign: 'right', alignSelf: 'end' }}
                    >
                      {currentEntitlement.entitlementDescription}
                    </Typography.Text>
                    <div style={{ width: '50%' }}>
                      <Switch
                        checked={formValues[`entitlement_${currentEntitlement.id}`]}
                        defaultChecked={false}
                        disabled={false}
                        loading={formValues[`loading_${currentEntitlement.id}`]}
                        name={`entitlement_${currentEntitlement.id}`}
                        onChange={(value) => {
                          const newFormValues = { ...formValues }
                          newFormValues[`entitlement_${currentEntitlement.id}`] = value
                          newFormValues[`loading_${currentEntitlement.id}`] = true
                          setFormValues(newFormValues)
                          if (value) {
                            associateProfileEntitlements(currentEntitlement.id)
                          } else {
                            disassociateProfileEntitlements(currentEntitlement.id)
                          }
                        }}
                        placeholder={getMessage('switch')}
                        unCheckedChildren={getMessage('label.no')}
                        checkedChildren={getMessage('label.yes')}
                      />
                    </div>
                  </div>
                </Col>
              )
            })}
          </Row>
        </div>
      )
    })
  }

  const { Option } = Select
  return (
    <>
      <PageHeader pageTitle="createProfile" match={match} history={history} createProfilePath="/profiles/create" />
      <Card className="ant-card gx-card ant-card-bordered">
        <Row style={{ marginBottom: 5, width: '102%' }}>
          <Col span={6}>
            <Typography>{getMessage('selectProfile')}</Typography>
            <Select
              style={{ margin: '5px 0px', width: '100%' }}
              value={formValues.profile}
              field={'selectedProfile'}
              onChange={(profile) => {
                onChangeSelectProfile(profile)
              }}
            >
              {profiles.map((r, index) => (
                <Option key={index} value={r.value}>
                  {r.description}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <div className="horizontal-line" style={{ margin: '20px 0px 20px' }} />
        {renderEntitlementsByGroupName()}
        <If condition={isLoading}>
          <div style={{ display: 'grid' }}>
            <Spin size="large" />
          </div>
        </If>
      </Card>
    </>
  )
}

export default EditProfile
